import { HOST_URL } from '../../config'
import { HttpStatus } from '../../constants/http-status.enum'
import type { ApiResponse } from '../index'
import type { IClientUID } from '../clients'

export interface IStaticTraits {
    version: string
    idfVer: string
    cores: number
    model: number
    revision: number
}

export async function getClientStaticTraits(clientId: IClientUID): Promise<ApiResponse<IStaticTraits>> {
    const response = await fetch(`${HOST_URL}static-traits`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ clientId }),
    })
    const result = (await response.json()) as ApiResponse<IStaticTraits>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}
